// @flow
import { ticketingSuggestionModalActions } from "./ticketingSuggestionModalActionCreator";

const initialState = {
  groupSuggestion: {
    isLoading: false,
    isLoaded: false,
    data: null
  },
  buTypes: {
    isLoaing: false,
    isLoaded: false,
    data: null
  },
  ticketTypes: {
    isLoading: false,
    isLoaded: false,
    data: null
  },
  ticketTypeDTO: {
    isLoading: false,
    isLoaded: false,
    data: null
  }
};

const ticketingSuggestionModalReducer = (
  state: Object = initialState,
  action: Object
) => {
  switch (action.type) {
    case ticketingSuggestionModalActions.GET_GROUP_SUGGESTION: {
      return Object.assign({}, state, {
        groupSuggestion: action.payload
      });
    }
    case ticketingSuggestionModalActions.GET_BU_TYPES_FOR_GROUP_SUGGESTION: {
      return Object.assign({}, state, { buTypes: action.payload });
    }
    case ticketingSuggestionModalActions.GET_TICKET_TYPES_FOR_GROUP_SUGGESTION: {
      return Object.assign({}, state, { ticketTypes: action.payload });
    }
    case ticketingSuggestionModalActions.GET_TICKET_TYPE_DTO_FOR_GROUP_SUGGESTION: {
      return Object.assign({}, state, { ticketTypeDTO: action.payload });
    }
    default: {
      return state;
    }
  }
};

export default ticketingSuggestionModalReducer;



// WEBPACK FOOTER //
// ./app/components/commons/ticketingSuggestionModal/ticketingSuggestionModalRedux/ticketingSuggestionModalReducer.js